import { render } from "./AppointmentView.vue?vue&type=template&id=1c6cd566&scoped=true"
import script from "./AppointmentView.vue?vue&type=script&lang=js"
export * from "./AppointmentView.vue?vue&type=script&lang=js"

import "./AppointmentView.vue?vue&type=style&index=0&id=1c6cd566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6cd566"]])

export default __exports__